import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { CopayGroupPayload } from '@/modules/HealthPlan/CopayAdjudication/CopayAdjudication.constant';
// import { useCurrentOrganization } from '@/modules/core/hooks';
import { QUERY_KEY } from '@/modules/HealthPlan/CopayAdjudication/queries/useCopayGroups.query';

export default () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (value: CopayGroupPayload) => api.delete(API_URL.COPAY_GROUPS_BY_ID(value.id || '')),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );
  return {
    isLoading,
    handleDelete: mutateAsync,
  };
};
